module.exports = __webpack_public_path__ + "static/media/BDBT03.870c13d4.jpg";